import { DynamicConfigs, useDynamicConfigs } from '@hungryroot/rest-hooks';
import { getUserAgentMatch } from '../utils/getUserAgentMatch';

export const useThirdPartySSODisabledUserAgentMatch = () => {
  const { data } = useDynamicConfigs({
    name: [DynamicConfigs.FunnelThirdPartySSODisabledUserAgents],
  });

  if (!data || !data.results || !data.results.length) {
    return false;
  }

  return getUserAgentMatch(data?.results[0]?.value);
};
